<template>
  <div>
    <!-- <van-button type="primary" @click="authorise()">授权</van-button> -->
  </div>
</template>

<script>
export default {
  created() {
    this.authorise();
  },
  methods: {
    authorise() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx259520b4c9549c29&redirect_uri=http://wxpt.sndyxzyyy.com/%23/home/&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    },
  },
};
</script>
+

<style lang="scss" scoped></style>
